import { SettingsSubscriptionContainer } from "../SettingsSubscriptionContainer";
import { useTranslation } from "next-i18next";
import { IUserSubscriptionModel } from "@nf/common";

type TPreviousSubscriptionContainerProps = {
  hasActiveSub: boolean;
  previousSubscriptions: IUserSubscriptionModel[];
};

export const PreviousSubscriptionContainer = ({
  hasActiveSub,
  previousSubscriptions,
}: TPreviousSubscriptionContainerProps) => {
  const { t } = useTranslation("translations");

  return (
    <>
      <h2>{t("web_subscription_previous")}</h2>
      {previousSubscriptions.map((sub) => {
        return (
          <SettingsSubscriptionContainer
            key={sub.Id}
            subscription={sub}
            hasActiveSub={hasActiveSub}
          />
        );
      })}
    </>
  );
};
